// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/dashboard\"},{\"path\":\"/edit\"},{\"path\":\"/inbox\"},{\"path\":\"/preview\"},{\"path\":\"/\"},{\"path\":\"/auth\"},{\"path\":\"/imprint\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.4";globalThis["_sentryRewritesTunnelPath"] = "/monterro";import * as Sentry from '@sentry/nextjs'
import { clientConfig } from './config/client.config'

if (clientConfig.sentry.enabled) {
    console.log('Sentry enabled?', {
        process: process.env.NEXT_PUBLIC_SENTRY_ENABLED,
        config: clientConfig.sentry.enabled,
    })
    console.log(
        'Sentry DSN present?',
        Boolean(process.env.NEXT_PUBLIC_SENTRY_DSN),
        'len',
        process.env.NEXT_PUBLIC_SENTRY_DSN?.length,
    )
    console.log(
        'Config :: Sentry DSN present?',
        Boolean(clientConfig.sentry.dsn),
        'len',
        clientConfig.sentry.dsn?.length,
        clientConfig.sentry.dsn?.length,
    )
    console.log('Sentry DSN has @ ?', process.env.NEXT_PUBLIC_SENTRY_DSN?.includes('@'))
    console.log('Client :: Sentry DSN has @ ?', clientConfig.sentry.dsn?.includes('@'))

    Sentry.init({
        dsn: clientConfig.sentry.enabled ? clientConfig.sentry.dsn : '',
        enabled: clientConfig.sentry.enabled,

        // Enable logs to be sent to Sentry
        enableLogs: clientConfig.sentry.enabled,

        // Add optional integrations for additional features
        integrations: [
            Sentry.replayIntegration({
                // Additional Replay configuration goes in here, for example:
                maskAllText: true,
                blockAllMedia: true,
            }),
            // Spotlight connects to localhost:8969 - only enable in development
            ...(process.env.NODE_ENV === 'development' ? [Sentry.spotlightBrowserIntegration()] : []),
            Sentry.captureConsoleIntegration({
                levels: ['log', 'info', 'warn', 'error', 'debug'],
            }),
        ],

        // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
        tracesSampleRate: clientConfig.sentry.enabled ? Number(clientConfig.sentry.tracesSampleRate) : 0,

        // Define how likely Replay events are sampled.
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: clientConfig.sentry.enabled
            ? Number(clientConfig.sentry.replaysSessionSampleRate)
            : 0,

        // Define how likely Replay events are sampled when an error occurs.
        replaysOnErrorSampleRate: clientConfig.sentry.enabled
            ? Number(clientConfig.sentry.replaysOnErrorSampleRate)
            : 0,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: clientConfig.sentry.debug,

        environment: clientConfig.sentry.environment,

        // Enable sending user PII (Personally Identifiable Information)
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: false,
    })
} else {
    console.log('Sentry client initialization skipped')
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
